export default "__VITE_ASSET__CO_3SLsQ__"